import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import IdleTimeout from "./components/IdleTimeout";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import Dashboard from "./pages/admin/Dashboard";
import Users from "./pages/admin/Users";
import AdminAttributes from "./pages/admin/AdminAttributes";
import Categories from "./pages/admin/Categories";
import Products from "./pages/admin/Products";
import CatalogMaster from "./pages/admin/CatalogMaster";
import BulkProductCreate from "./pages/admin/BulkProductsCreate";
import SubCategoryColorImages from "./pages/admin/SubCategoryColorImages";
import Profile from "./pages/Profile";
import SearchResults from "./pages/customer/SearchResults";
import ProductList from "./pages/customer/ProductList";
import MyOrders from "./pages/MyOrders";
import ProtectedRoute from "./components/ProtectedRoute";
import Cart from "./pages/customer/Cart";
import AppLayout from "./components/AppLayout";
import SubCategoryListing from "./pages/customer/SubCategoryListing";
import HomePage from "./pages/customer/HomePage";
import OrderSuccess from "./pages/customer/OrderSuccess";

export default function App() {
  return (
    <BrowserRouter>
      {/* <IdleTimeout /> */}
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Admin Dashboard */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <Dashboard />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Users (Admin + Manager) */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={["admin", "manager"]}>
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/attributes"
          element={
            <ProtectedRoute roles={["admin", "manager"]}>
              <AppLayout>
                <AdminAttributes />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Categories */}
        <Route
          path="/admin/categories"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <Categories />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/catalog"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <CatalogMaster />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/subcategory-color-images"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <SubCategoryColorImages />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Products */}
        <Route
          path="/admin/products"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <Products />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/bulk-products"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AppLayout>
                <BulkProductCreate />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Profile (All Logged In Users) */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Profile />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* All Products (All Logged In Users) */}
        <Route
          path="/product-list"
          element={
            <ProtectedRoute roles={["customer"]}>
              <AppLayout>
                <ProductList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/order-success"
          element={
            <ProtectedRoute roles={["customer"]}>
              <AppLayout>
                <OrderSuccess />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/home"
          element={
            <ProtectedRoute roles={["customer"]}>
              <AppLayout>
                <HomePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/search"
          element={
            <ProtectedRoute roles={["customer"]}>
              <AppLayout>
                <SearchResults />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/subcategories/:categoryId"
          element={
            <ProtectedRoute roles={["customer"]}>
              <AppLayout>
                <SubCategoryListing />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-orders"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MyOrders />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/:slug"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ProductList />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Cart />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        {/* Default Redirect */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
